import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import ArrayField from './array-field/index.js';
import ObjectField from './object-field/index.js';
import ScalarField from './scalar-field/index.js';

function isUnion(schema) {
  const oneOf = schema.get('oneOf');
  return oneOf?.every((schema) => schema.get('type') === 'object' || schema.get('$ref'));
}

export default class SchemaField extends PureComponent {
  static propTypes = {
    resolveRef: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired,
    schemaPath: PropTypes.array.isRequired,
    formName: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    config: PropTypes.object.isRequired,
    forms: PropTypes.object,
    context: PropTypes.object,
    widgets: PropTypes.object,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    locale: PropTypes.string
  };

  render() {
    const { config, widgets, resolveRef } = this.props;
    let { schema } = this.props;
    const ref = schema.get('$ref');
    if (ref) {
      schema = resolveRef(schema);
    }

    const type = schema.get('type');

    let Component;
    if (config && widgets && widgets[config.get('widget')]) {
      // Handle custom widget
      Component = ScalarField;
    } else if (type === 'object' || isUnion(schema)) {
      Component = ObjectField;
    } else if (type === 'array') {
      Component = ArrayField;
    } else {
      Component = ScalarField;
    }

    return <Component {...this.props} schema={schema} />;
  }
}
